import React from "react";
import PropTypes from "prop-types";
import Button from "material-ui/Button";
import TextField from "material-ui/TextField";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "material-ui/Dialog";

class EditVideoDialog extends React.Component {
  static propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func.isRequired,
    handleVideoUpdated: PropTypes.func.isRequired,
    video: PropTypes.objectOf(PropTypes.any),
  };

  static defaultProps = {
    open: false,
    video: {
      title: "",
      description: "",
    },
  };

  state = {
    title: "",
    description: "",
  };

  componentWillMount() {
    if (this.props.video) {
      this.setState({
        title: this.props.video.videoTitle || "",
        description: this.props.video.description || "",
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.video && nextProps.video !== this.props.video) {
      this.setState({
        title: nextProps.video.videoTitle || "",
        description: nextProps.video.description || "",
      });
    }
  }

  handleOk = () => {
    this.props.handleVideoUpdated(this.props.video, {
      videoTitle: this.state.title,
      description: this.state.description,
    });

    this.handleClose();
  };

  handleClose = () => {
    this.setState({
      title: "",
      description: "",
    });

    this.props.handleClose();
  };

  handleTitleChange = (e) => {
    this.setState({
      title: e.target.value,
    });
  };

  handleDescriptionChange = (e) => {
    this.setState({
      description: e.target.value,
    });
  };

  moveCaretAtEnd = (e) => {
    const tempValue = e.target.value;
    e.target.value = "";
    e.target.value = tempValue;
  };

  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Éditer une vidéo</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Modifier le titre et/ou la description de la vidéo.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="title"
            label="Titre"
            type="text"
            fullWidth
            value={this.state.title}
            onChange={this.handleTitleChange}
            onFocus={this.moveCaretAtEnd}
          />

          <TextField
            margin="dense"
            id="Description"
            label="Description"
            type="text"
            fullWidth
            value={this.state.description}
            onChange={this.handleDescriptionChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose} color="primary">
            Annuler
          </Button>
          <Button onClick={this.handleOk} color="primary">
            Valider
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default EditVideoDialog;



// WEBPACK FOOTER //
// ./src/pages/playlists/form/videos/EditVideoDialog.jsx